import React from 'react';
import PropTypes from 'prop-types';
import { FlexGrid, Header } from '@gasbuddy/react-components';
import styles from './styles.css';

const GridColumns = ({ contents, centered, className }) => (
  <FlexGrid className={`${styles.gridContainer} ${className} ${centered ? styles.gridCentered : ''}`} columns={contents.length}>
    {contents.map(content => (
      <FlexGrid.Column key={content.title || content.key} className={styles.gridColumn}>
        {content.title && <Header as="h5" style={{ margin: '15px 0' }}>{content.title}</Header>}
        <div className={styles.columnContainer}>
          {content.body ? content.body : (<div><p>{`No selected ${content.title}`}</p></div>)}
        </div>
      </FlexGrid.Column>
    ))}
  </FlexGrid>
);

GridColumns.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
      key: PropTypes.string,
    }),
  ),
  centered: PropTypes.bool,
  className: PropTypes.string,
};

GridColumns.defaultProps = {
  contents: [],
  centered: false,
  className: '',
};

export default GridColumns;
